// TES-966 — the Tab wrap for the phone nav drawer's focus trap.
//
// Pure on purpose (no DOM, no React) so `node --test` can run it; the shell
// owns the element list and the keydown listener.

/**
 * Where Tab (or Shift+Tab) must send focus to keep it inside a trap of
 * `count` focusable elements, given the index of the one that has focus now
 * (-1 when focus is outside the trap). Returns null when the browser's own
 * move stays inside the trap and nothing needs to be done.
 */
export function trappedFocusIndex(
  current: number,
  count: number,
  backwards: boolean,
): number | null {
  if (count === 0) return null;
  const last = count - 1;
  if (current < 0) return backwards ? last : 0;
  if (backwards && current === 0) return last;
  if (!backwards && current === last) return 0;
  return null;
}
